"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FlyOut = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactPortal = require("react-portal");

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

var _flyoutMenu = _interopRequireDefault(require("./flyout-menu"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var FlyOut = function FlyOut(_ref) {
  var label = _ref.label,
      children = _ref.children,
      className = _ref.className,
      buttonClassName = _ref.buttonClassName,
      listClassName = _ref.listClassName,
      hideOnItemClick = _ref.hideOnItemClick,
      disabled = _ref.disabled;
  var intl = (0, _nicbaseTranslation.useIntl)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showItems = _useState2[0],
      setShowItems = _useState2[1];

  var _useState3 = (0, _react.useState)({
    top: 0,
    left: 0,
    width: 0,
    height: 0
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      anchor = _useState4[0],
      setAnchor = _useState4[1];

  var buttonRef = (0, _react.useRef)();

  var onCloseMenu = function onCloseMenu() {
    return setShowItems(false);
  };

  var onShowItems = function onShowItems() {
    if (!disabled) {
      var _buttonRef$current$ge = buttonRef.current.getBoundingClientRect(),
          top = _buttonRef$current$ge.top,
          left = _buttonRef$current$ge.left,
          height = _buttonRef$current$ge.height,
          width = _buttonRef$current$ge.width;

      var _window = window,
          scrollY = _window.scrollY,
          scrollX = _window.scrollX;
      setAnchor({
        top: top + scrollY,
        left: left + scrollX,
        height: height,
        width: width
      });
      setShowItems(true);
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('inline-block relative text-primary', className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('outline-none border-none cursor-pointer', buttonClassName, {
      'text-gray-200 fill-gray-200': disabled
    }),
    onClick: onShowItems,
    ref: buttonRef
  }, label || /*#__PURE__*/_react["default"].createElement("span", {
    title: intl.formatMessage({
      id: 'forms.flyOut.title'
    })
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.ThreeDots, {
    className: "pointer-events-none"
  }))), showItems && /*#__PURE__*/_react["default"].createElement(_reactPortal.Portal, null, /*#__PURE__*/_react["default"].createElement(_flyoutMenu["default"], {
    onCloseMenu: onCloseMenu,
    anchor: {
      x: anchor.left,
      y: anchor.top,
      width: anchor.width,
      height: anchor.height
    },
    className: listClassName
  }, _react["default"].Children.toArray(children).map(function (child) {
    return /*#__PURE__*/_react["default"].cloneElement(child, {
      onClick: function onClick() {
        if (hideOnItemClick) {
          setShowItems(false);
        }

        if (child.props.onClick) {
          var _child$props;

          (_child$props = child.props).onClick.apply(_child$props, arguments);
        }
      }
    });
  }))));
};

exports.FlyOut = FlyOut;
var _default = FlyOut;
exports["default"] = _default;
FlyOut.defaultProps = {
  disabled: false,
  children: null,
  className: '',
  buttonClassName: '',
  listClassName: '',
  hideOnItemClick: false,
  label: ''
};